import { render, staticRenderFns } from "./AsetTanahDetail.vue?vue&type=template&id=93ae7ad2"
import script from "./AsetTanahDetail.vue?vue&type=script&lang=js"
export * from "./AsetTanahDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports